// src/components/DeleteConfirmationModal.js

import React from 'react';
import '../stylings/DeleteConfirmationModal.css';

function DeleteConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  announcementTitle 
}) {
  if (!isOpen) return null;
  
  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div 
        className="delete-modal-content" 
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Delete Announcement</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="delete-modal-body">
          <div className="delete-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 6h18"></path>
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
            </svg>
          </div>
          
          <p className="delete-message">
            Are you sure you want to delete the announcement <span className="announcement-title">"{announcementTitle}"</span>?
          </p>
          <p className="delete-warning">
            This action cannot be undone.
          </p>
        </div>
        
        <div className="delete-modal-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-confirm-btn" onClick={onConfirm}>
            Delete Announcement
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;